import React from 'react'
 import PreviewComponent from '../Preview'
import { Tooltip } from '@material-ui/core'
import { useState, useContext, useEffect } from 'react'
import { GlobalContext } from '../../Context/GlobalContext'
import { parseTime } from '../../Helpers/parse'
import { timezones } from '../../utils/timezones'

const PremieredVideoItem = ({videoObj}) => {
  const { thumbnailSize } = useContext(GlobalContext);
  const [date, setDate] = useState(new Date());
  const [timezone, setTimezone] = useState('America/Los_Angeles');

  useEffect(() => {
    setDate(videoObj?.premiereDate);
    if (videoObj?.premiereDateTimezone) {
      setTimezone(videoObj?.premiereDateTimezone);
      const options = { timeZone: videoObj?.premiereDateTimezone };
      setDate(new Date(videoObj?.premiereDate).toLocaleString('en-US', options));
    } else {
      const newTime = new Intl.DateTimeFormat().resolvedOptions()?.timeZone;
      setTimezone(newTime);
    };
  }, []);

  /**
   * convert timezone value into abbreviation
   * @param {*} timeZone - timezone value
   * @returns abbreviation of timezone
   */
  const timezoneAbbrev = (timeZone) => {
    try {
        const findAbbrev = timezones.find((item) => item?.value === timeZone);
        if (findAbbrev) {
            return findAbbrev?.abbreviation;
        } else {
            const timeValue = new Intl.DateTimeFormat().resolvedOptions()?.timeZone;
            const newFind = timezones.find((item) => item?.value === timeValue);
            return newFind?.abbreviation ? newFind?.abbreviation : 'UTC';
        };
    } catch (err) {
        console.error(err);
        return 'UTC';
    }
  };

  // correctly format premiere date
  const handleFormatTitle = (currDate) => {
    const newDate = new Date(currDate);
    return `${newDate.getMonth()+1}/${newDate.getDate()}/${newDate.getFullYear()} @ ${parseTime(newDate)} ${timezoneAbbrev(timezone)}`;
  };

  return (
    // <Tooltip placement='top' title={`This video is scheduled to be premiered on ${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()} @ ${parseTime(date)}`}>
    <Tooltip placement='top' title={`This video is scheduled to be premiere on ${handleFormatTitle(date)} `}>
      <div
          className="col-3 mb-3"
          id={thumbnailSize}
        >
          <PreviewComponent
            item={videoObj._id}
            file={videoObj._id} 
            premiereDate={date}
            premiering={true}
          />
          {videoObj.metadata.filename} 
        </div>
      </Tooltip> 
  )
}


export default PremieredVideoItem